import EcoNavProduct, { EcoNavProductProps } from 'eco-design/sections/eco-nav-product';
import { useRouter } from 'next/router';
import { productPageUrl } from '../../config/pageConfig';
import styles from './index.module.scss';
import { LangText } from './LangText';
import { useProductDispatch, useProductStore } from '../../ProductStationProvider';

export default function ProductNav({ activeTab, tabCallback }: { activeTab: string; tabCallback?: any }) {
    const { locale = 'us', pathname } = useRouter();
    const TextA = LangText[locale] || LangText['us'];
    const thePageUrl = `/${locale}/${productPageUrl}`;
    const isInProductPage = pathname.endsWith(productPageUrl);
    const dispatch = useProductDispatch();
    const router = useRouter();

    const dataA: EcoNavProductProps = {
        productItems: [
            {
                value: 'name1',
                label: TextA.product_name,
            },
        ],
        tabItems: [
            {
                value: 'Product',
                label: TextA.tab_product,
                href: isInProductPage ? undefined : thePageUrl,
            },
            {
                value: 'Specs',
                label: TextA.tab_specs,
                href: `${thePageUrl}/specs`,
            },
            {
                value: 'Support',
                label: TextA.tab_support,
                href: `${thePageUrl}/support`,
            },
        ],
        buyItems: [
            {
                value: 'Buy',
                label: TextA.btn_buy,
                href: '#RV-SectionE',
            },
        ],
        dataLayerBuy: {
            event: 'uaEvent',
            event_name: 'product_navigation',
            navigation_name: TextA.btn_buy,
            product_name: 'EcoFlow 第二世代 Alternator Charger シリーズ',
            __btn_id1: `RV-ProductNav .eco-nav-product-btn-buy`,
            __btn_id2: 'Buy',
            __btn_type: 'common',
        },
    };
    const tabChange = (item: any, index: number) => {
        if (tabCallback) {
            tabCallback(item.value);
        }
    };
    const handleBuyChange = (item: any, index: number) => {
        if (item.value === 'Buy') {
            router.push('/on-the-road-power-solution#RV-SectionE');
            return;
        }
        dispatch({
            type: 'changeProductTabActive',
            payload: item.value,
        });
    };

    return (
        <div className={`${styles.comp}  RV-ProductNav`}>
            <EcoNavProduct {...dataA} defaultTabActiveKey={activeTab} onTabChange={tabChange} onBuyChange={handleBuyChange} />
        </div>
    );
}
